import React from 'react';

const Payments = () => {
  return <h2>Payments Management Page</h2>;
};

export default Payments;